import { getAuthHeaderValue } from "@src/appV2/Auth/cognito/getAuthorizationHeader";

export const getAuthHeader = async () => {
  const authHeaderValue = await getAuthHeaderValue();

  return { Authorization: authHeaderValue };
};
